import { WizardStepName } from 'data/ppoints/constants';
import useMarketDrivenShippingStatus from 'hooks/useMarketDrivenShippingStatus';
import { useTranslation } from 'react-i18next';

export const useWizardTitle = (title: WizardStepName | null) => {
    const { t } = useTranslation();
    const { isLegacy } = useMarketDrivenShippingStatus();

    let translatedTitle: string | null = null;

    if (!title) return null;

    // TODO switch wizard step names

    switch (title) {
        case WizardStepName.choose_service_provider:
            return (translatedTitle = t('WIZARD.SERVICE_PROVIDER_STEP.TITLE'));
        case WizardStepName.shipping_zone_rate:
            // Market-driven shops render this step as MarketRateStep instead of ShippingZoneRateStep
            // (see ShippingRateStep) — the stepper title needs to follow the same switch.
            return (translatedTitle = isLegacy
                ? t('WIZARD.SHIPPING_ZONE_RATE_STEP.TITLE')
                : t('WIZARD.MARKET_DRIVEN_SHIPPING_STEP.TITLE'));
        case WizardStepName.integration_mode_step:
            return (translatedTitle = t('WIZARD.INTEGRATION_MODE_STEP.TITLE'));
        case WizardStepName.app_extensions:
            return (translatedTitle = t('WIZARD.INTEGRATION_STATUS_STEP.TITLE'));
        case WizardStepName.summary:
            return (translatedTitle = t('WIZARD.SUMMARY_STEP.TITLE'));
    }

    return translatedTitle;
};
